<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Form - Receiving Posting <span v-if="(model.partialRcv==1)">(as AP UNBILL)</span>
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-form-row>
                        <b-col md="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Receiving Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.RecivNo" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Receiving Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" disabled></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-form-row >                      
                    <b-input-group >
                        <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.vendorinfo" :state="!$v.model.vendor.$error"></b-form-input>
                    </b-input-group>
                    <b-form-row>
                        <b-col md="6">
                            <b-input-group >
                                <b-input-group-prepend><label>PO/SO No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.po" :state="!$v.model.po.$error"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="6">                            
                            <b-input-group v-if="model.partialRcv==1">
                                <b-form-checkbox disabled class="ml-2 mt-2" v-model="model.partialRcv" value=1 unchecked-value=0>
                                    Partial Receiving
                                </b-form-checkbox>
                            </b-input-group>
                            <!-- <b-input-group v-else>
                                <b-input-group-prepend><label>Invoice DP/Termin</label></b-input-group-prepend>
                                <b-form-select v-model="model.tagihandp" :plain="true" :options="YesNo" :state="!$v.model.tagihandp.$error"></b-form-select>
                                <b-input-group-append>
                                    <span class="input-group-text">Termin #</span>
                                </b-input-group-append>
                               <b-form-select v-model="model.termin" :plain="true" :options="invoiceTerms" :state="!$v.model.termin.$error" :disabled="(model.tagihandp == 0)"></b-form-select>
                            </b-input-group> -->
                        </b-col>
                    </b-form-row>                      
                    <b-form-row>
                        <b-col cols="7" >
                            <b-input-group >
                                <b-input-group-prepend><label>Receiving Amount</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.totalinv" :precision="2" :state="!$v.model.totalinv.$error" disabled></my-number>
                                    <!-- <b-input-group-append>
                                        <b-form-checkbox id="chkGrossUp" class="ml-1 mt-2" v-model="model.grossup" value=1 unchecked-value=0>
                                        Gross Up
                                        </b-form-checkbox>
                                    </b-input-group-append> -->
                            </b-input-group>
                        </b-col>
                        <b-col cols="5">                            
                            <b-input-group >
                                <b-input-group-prepend><span class="input-group-text">Exch. Rate {{model.matauang}}</span></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number :disabled="(model.matauang === uanguser)" class="form-control text-right" separator="," v-model="model.ratekurs" v-b-tooltip.hover title="Kurs Akhir Bulan Lalu"></my-number>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                </b-col>
                <b-col md="4">
                        <!-- <b-input-group >
                            <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')" :state="!$v.model.kodecash.$error"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="showLkuCashflow('model')" id="apKodecash">
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group> -->
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblApLines"
                    outlined striped hover small
                    style="font-size:smaller;" 
                    :items="apLines.items"
                    :fields="apLines.fields"
                    :current-page="apLines.page"
                    :per-page="apLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(unitprice)="data">
                        {{data.item.unitprice|numFormat}}
                        </template>
                        <template v-slot:cell(nilai)="data">
                        {{data.item.nilai|numFormat}}
                        </template>
                        <template v-slot:cell(nilaippn)="data">
                        {{data.item.nilaippn|numFormat}}
                        </template>
                        <template v-slot:cell(nilaidue)="data">
                        {{data.item.nilaidue|numFormat}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editApLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delApLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                        <b-row>
                        <b-col md="8">
                            <b-row>
                                <b-col lg="10">
                                    <b-input-group>
                                        <b-input-group-prepend><label>Posting Account</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="apLinesObj.glAccount" @keyup.13.native="lkuCoaShow=true" :state="!$v.apLinesObj.kodeacc.$error" style="width:40% !important;"></b-form-input>
                                        <b-input-group-append>
                                            <b-btn text="Button" @click="lkuCoaShow=true"> <i class="fa fa-search"></i></b-btn>
                                        </b-input-group-append>
                                        <b-input-group-prepend><span class="input-group-text">Posting As</span></b-input-group-prepend>
                                        <b-form-select v-model="apLinesObj.posttype" :plain="true" :options="posttypes" :state="!$v.apLinesObj.posttype.$error" disabled></b-form-select>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            <b-input-group>
                                <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                                <b-form-input v-model="apLinesObj.itemname" disabled style="width:50% !important;"></b-form-input>
                                <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Quantity</span></b-input-group-prepend>
                                <b-form-input v-model="apLinesObj.quantity" @change="calcPrice()" type="number" :precision="2"></b-form-input>
                                <b-form-input v-model="apLinesObj.unitsize" placeholder="Unit Size" class="ml-1" ></b-form-input>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                <b-form-input v-model="apLinesObj.uraian_dt" ></b-form-input>
                            </b-input-group>

                            <b-row>
                              <b-col md="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>Unit Price</label></b-input-group-prepend>
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="apLinesObj.unitprice" :precision="2" :state="!$v.apLinesObj.unitprice.$error"></my-number>
                                    <b-form-checkbox :value="1" :unchecked-value="0" v-model="apLinesObj.kenappn" class="ml-1 mt-2"> PPN(VAT In)</b-form-checkbox>
                                </b-input-group>
                              </b-col>
                              <b-col md="6">                            
                                <b-input-group v-if="(apLinesObj.kenappn == 1)">
                                    <b-input-group-prepend><label>tarif PPN</label></b-input-group-prepend>
                                    <b-form-input v-model="apLinesObj.ppn" @change="calcTaxes()" type="number" ></b-form-input>
                                    <b-input-group-append> <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>
                                </b-input-group>
                              </b-col>
                            </b-row >                      
                            <b-row>
                              <b-col md="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>Net Amount</label></b-input-group-prepend>
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="apLinesObj.nilai" :precision="2" disabled :state="!$v.apLinesObj.nilai.$error"></my-number>
                                </b-input-group>
                              </b-col>
                            </b-row >                      

                            <!-- 
                            <b-form-row>
                              <b-col  md="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>PPN Masukan</label></b-input-group-prepend>
                                    <b-form-select v-model="apLinesObj.kenappn" :plain="true" :options="YesNo" @change="calcTaxes()" :state="!$v.apLinesObj.kenappn.$error"></b-form-select>
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">tarif</span>
                                    </b-input-group-prepend>
                                    <b-form-input v-model="apLinesObj.ppn" @change="calcTaxes()" type="number" ></b-form-input>
                                </b-input-group>
                              </b-col>
                              <b-col md="5">                            
                                <b-input-group>
                                    <b-input-group-prepend><span style="padding-top:5px;padding-right:5px;">Tarif DPP terhadap NetAmount</span></b-input-group-prepend>
                                    <b-form-input v-model="apLinesObj.dppnlain"  type="number" @change="calcTaxes()"></b-form-input>
                                    <b-input-group-append><span class="input-group-text"> % * NetAmount</span></b-input-group-append>
                                </b-input-group>
                              </b-col>
                            </b-form-row >                       
                            -->
                            <!-- 
                            <b-form-row>
                              <b-col md="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                    <b-form-select v-model="apLinesObj.pasalpph" :plain="true" :options="lookupPPH" :state="!$v.apLinesObj.pasalpph.$error"></b-form-select>
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">tarif</span>
                                    </b-input-group-prepend>
                                    <b-form-input v-model="apLinesObj.pph" type="number" @change="calcTaxes()" :precision="2"></b-form-input>
                                    <b-input-group-append> <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>
                                 </b-input-group>
                              </b-col>
                              <b-col md="6">                            
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <b-form-select style="width:158px;"  v-model="calcPPh" :plain="true" :options="calcuationPPH" ></b-form-select>
                                    </b-input-group-prepend>
                                    <b-input-group-prepend>
                                        <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="apLinesObj.nilaipph" :precision="2" :readonly="(calcPPh===1)"></my-number>
                                </b-input-group>
                              </b-col>
                            </b-form-row >                       
                            -->
                        </b-col>
                        <b-col md="4">
                            <v-dim :model="apLinesObj" :key="updateDimDtl" ></v-dim>
                            
                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mt-1">
                            <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveApLines()">Update</b-button>
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row >
                    <b-col cols="5">
                        <b-row class="pt-1">
                        <b-button size="sm" class="ml-3" @click="addApLines" >Add AP Detail</b-button>                          
                        <div class="ml-2">
                            Showing {{(apLines.page - 1) * apLines.limit + 1}}
                            to <span v-if="((apLines.page * apLines.limit)>apLines.total)">{{apLines.total}}</span> <span v-else>{{apLines.page * apLines.limit}}</span>
                            of {{apLines.total}} entries
                        </div>
                        </b-row>                    
                    </b-col>
                    <b-col cols="3" >
                        <div class="pt-1">
                            Limit per page
                            <input type="number" style="width:80px;" v-model="apLines.limit"/>
                        </div>
                    </b-col>        
                    <b-col cols="4">            
                    <b-pagination
                        align="right"
                        :total-rows="apLines.total"
                        :per-page="apLines.limit"
                        v-model="apLines.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
              </b-card>    
                <b-row align-h="between" class="mt-1">
                    <b-col lg="8" xl="7">
                        <b-input-group>
                            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                            <b-form-input  v-model="model.uraian" :state="!$v.model.uraian.$error"></b-form-input>
                        </b-input-group>
                        <!-- 
                        <b-form-row>
                            <b-col md="4">
                                <b-input-group >
                                    <b-input-group-prepend><label>No. Faktur Pajak</label></b-input-group-prepend>
                                    <b-form-input v-model="model.nofaktur" ></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col md="4">
                                <b-input-group >
                                    <b-input-group-prepend><label style="width:70px;">Tgl. Faktur</label></b-input-group-prepend>
                                    <b-form-input v-model="model.tglfaktur" type="date" ></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col md="4">
                                <b-input-group >
                                    <b-input-group-prepend><label>Kurs Pajak {{model.matauang}}</label></b-input-group-prepend>
                                    <my-number :disabled="(model.matauang === uanguser)" class="form-control text-right" separator="," v-model="model.kursppn" ></my-number>
                                </b-input-group>
                            </b-col>
                        </b-form-row>     
                        -->
                        <b-form-row>
                            <b-col md="10" lg="7">
                                <b-input-group>
                                    <b-input-group-prepend><label>AP Posting Group</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="model.postgrpname" :state="!$v.model.postgroup.$error"></b-form-input>
                                    <!-- <b-form-select v-model="model.postgroup" :plain="true" :options="postGroups" :state="!$v.model.postgroup.$error"></b-form-select> -->
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuApGroupShow=true" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                            <!-- 
                            <b-col md="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                    <b-input-group-prepend>
                                        <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="model.totalpph" :precision="2" disabled></my-number>
                                </b-input-group>
                            </b-col> 
                            -->
                        </b-form-row>      
                        <b-form-row v-if="(model.partialRcv==0)">
                            <b-col md="5">
                                <b-input-group >
                                    <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
                                    <b-form-input v-model="model.invoice" :state="!$v.model.po.$error"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col md="7">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Invoice Date</span></b-input-group-prepend>
                                    <b-form-input v-model="model.invdate" type="date"></b-form-input>
                                    <b-input-group-prepend><span class="p-1" style="background-color: #f0f3f5;border: 1px solid #e4e7ea;">Due</span></b-input-group-prepend>
                                    <b-form-input v-model="model.duedate" type="date"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-form-row> 

                    </b-col>
                    <b-col md="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">subtotal</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend>
                                <b-form-select style="width:158px;"  v-model="calcVAT" :plain="true" :options="calcuationVAT" disabled></b-form-select>
                                </b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.nilaippn" :precision="2" :readonly="(calcVAT===1)" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                                <b-form-checkbox  class="ml-2 mt-2" v-model="model.chargeable" value=1 unchecked-value=0>
                                Chargeable to Customer
                                </b-form-checkbox>
                            </b-input-group>

                        </div>
                    </b-col>
                </b-row>
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>
        </b-card>
        <!-- 
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
                <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData" typeacc="OUT"></lku-cashflow>
        </b-modal>         
        -->
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuApGroupShow" size="lg" :hide-footer="true" title="List of AP Posting Group" :centered="true">
            <lku-appostinggrp @click="onSelectLkuApGroup"></lku-appostinggrp>
        </b-modal>        
        <b-modal v-model="dpConfirm" size="lg" title="List of Invoice DP/Termin" 
            :centered="true"  header-bg-variant="primary" :hide-footer="true" :no-close-on-esc="true" :no-close-on-backdrop="true" :hide-header-close="true">
            <div class="report-wraper">
                    <table style="width: 100%;" class="">
                        <thead>
                            <tr>
                            <th width="30px"></th>
                            <th style="text-align:center" width="100px">Settled Amount</th>
                            <th style="text-align:center" width="100px">AP Number</th>
                            <th style="text-align:center" width="100px">Invoice No.</th>
                            <th style="text-align:center" width="100px">PO Number</th>
                            <th>Description</th>
                            <th style="text-align:center" width="30px">Rp,$,¥</th>
                            <th style="text-align:center" width="120px">Invoice Total (Excl.VAT)</th>
                            <th style="text-align:center" width="100px">UnSettled Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in apDownpay" :key="row.notgl" >
                                <td width="30px">    
                                    <b-form-checkbox v-model="row.selected" :value="1" :unchecked-value="0"/>
                                </td>
                                <td style="margin:0;padding:0;"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;" >
                                    <my-number v-model="row.nilai"  class="form-control text-right"  style="border:none;font-size: 0.8rem !important;" :precision="2" ></my-number></div>
                                </td>
                                <td>{{row.nomor}}</td>
                                <td>{{row.invoice}}</td>
                                <td>{{row.po}}</td>
                                <td>{{row.uraian}}</td>
                                <td width="30px">{{row.matauang}}</td>
                                <td style="text-align:right">{{row.totalinvxppn | numFormat('0,0.00')}}</td>
                                <td style="text-align:right">{{row.SisaDP | numFormat('0,0.00')}}</td>
                            </tr>
                        </tbody>
                    </table>
            </div>                  
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="success" class="ml-1" @click="onSelectApDownpay" > <i class="fa fa-check-circle-o"></i> Confirm</b-button>
                  <b-button variant="danger" class="ml-1" @click="onCancelApDownpay" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
        </b-modal>        
    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
        .input-group {
            padding-bottom:2px;
            .input-group-prepend {
                label {
                    padding-top: 5px;
                    padding-right: 5px;
                    width: 110px;
                }
            }
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuAppostinggrp from "../lookup/lkuApGroup";
// import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCoa from "../lookup/lkuCoa";
import apinv from "../../apis/apinv";
// import procure from "../../apis/procure";
import procreceiv from "../../apis/procreceiv";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, requiredUnless, minValue, maxLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
//   components: { myNumber, vDim, lkuAssetcat, lkuCashflow,lkuCoa},
  components: { myNumber, vDim, lkuAppostinggrp,lkuCoa},
  mixins: [validationMixin],
  validations: {
        model: {
            vendor: { required },
            po: { required:requiredIf('use_procure') },
            uraian: { required },
            tanggal: { required },
            postgroup: { required },
            kodecash: { required:false },
            matauang: { required },
            tagihandp: { required },
            termin: { required:requiredIf('tagihandp') },
            // nofaktur: {required : (function() {
            //     if ((this.model.nilaippn || 0) == 0) {
            //         return true;
            //     } else if ((this.model.nofaktur || '')==''){
            //         return false;
            //     } else return true;
            // })},
            // tglfaktur: {required : (function() {
            //     if ((this.model.nilaippn || 0) == 0) {
            //         return true;
            //     } else if (!(this.model.tglfaktur)){
            //         return false;
            //     } else return true;
            // })},
            totalinv: { required, minValue:minValue(1) },
            ratekurs: { required, minValue:minValue(0.00000001) }

        },
        apLinesObj: {
            kodeacc: { required },
            posttype: { required },
            uraian_dt: { required },
            quantity: { required, minValue:minValue(0.00000001) },
            unitprice: { required, minValue:minValue(0.00000001) },
            nilai: { required, minValue:minValue(0.00000001) },
            // ppn: { numeric },
            // kenappn: { required },
            pasalpph: {required : (function() {
                if ((this.apLinesObj.nilaipph || 0) == 0) {
                    return true;
                } else if (((this.apLinesObj.pasalpph || '')=='') || (this.apLinesObj.pasalpph== 'N/A') || (this.apLinesObj.pasalpph== 'NO WHT')){
                    return false;
                } else return true;
            })},
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        // lkuCashflowData: {},
        // lkuCashflowShow: false,
        // lkuCashflowCaller:'model',        
        // lkuAssetcatShow: false,
        updateDimHdr:false,
        updateDimDtl:true,
        tarifPPN: this.$store.state.user.tarifppn || 11,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        lkuCoaShow:false,
        coa:[],
        uanguser: this.$store.state.user.matauang,
        postGroups:[],
        currency:[{value:'IDR',text:'IDR'}],
        invoiceTerms: [{ value: '', text: '-' }, { value: 'Term#1', text: 'Term#1' }, { value: 'Term#2', text: 'Term#2' },
                { value: 'Term#3', text: 'Term#3' }, { value: 'Term#4', text: 'Term#4' }
        ],
        calcVAT:0,
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Otomatis)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[],
        posttypes : [{ value: 1, text: 'INVENTORY' }, { value: 2, text: 'ASSET' },{ value: 3, text: 'EXPENSES' }],
        YesNo :   [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }],
        // model:{vendor:'',po:'',kodecash:'', tagihandp:0, termin:'', nilaippn:0, nofaktur:'', tglfaktur:'', DimTableKey:'', matauang:'IDR', postgroup:''},
        model: {
            vendor: '',
            po: '',
            uraian: '',
            tanggal: '',
            postgroup: '',
            kodecash: '',
            matauang: 'IDR',
            tagihandp: 0,partialRcv:0,
            termin: '',
            nofaktur: '',
            tglfaktur: '',
            totalinv: 0, nilaippn:0,grossup:0, totalpph:0,
            ratekurs: 1, kursppn:1, DimTableKey:'',
            top:0,//term of payment,
            duedate:'',invdate:''        
        },
        Lines:[], //additional 28 May 2021 
        ordLines:{}, //additional 28 May 2021      
        otherRcv:{}, //additional 28 May 2021   
        partialRcvConfirm:false,   
        apLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "uraian_dt",
                    label: "Description",
                },
                {
                    key: "postname",
                    label: "Posting As",
                    thStyle: "width:140px",
                    variant: 'danger'
                },
                {
                    key: "kodeacc",
                    label: "GL Account"
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:90px",
                },
                {
                    key: "unitprice",
                    label: "Unit price",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilai",
                    label: "Amount NETT",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaippn",
                    label: "Amount VAT",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaidue",
                    label: "Amount DUE",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        apLinesObj:{ 
            kodeacc: '',
            uraian_dt: '',
            quantity: 0,
            unitprice: 0,
            nilai: 0, nilaipph:0,
            ppn: 0,
            kenappn: 0,
            pasalpph: 'NO WHT',
            pph: 0, unitzise:'', DimTableKey:'', amortzbln:0, amortzdate:'',
            amortzkodeacc:'',amortznamaacc:'',amortzaccount:'', posttype:''},
        saveClick:false,
        apDpSttl: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nilai",
                    label: "Settled Amount",
                    thStyle: "width:140px",
                    thClass: "text-center",
                    tdClass: "text-right"
                },
                {
                    key: "nomor",
                    label: "AP Number",
                    thStyle: "width:140px",
                },
                {
                    key: "invoice",
                    label: "Invoice No.",
                    thStyle: "width:140px",
                },
                {
                    key: "po",
                    label: "PO Number",
                    thStyle: "width:140px",
                },
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥",
                    sortable: true
                },
                {
                    key: "totalinvxppn",
                    label: "Total Invoice\ (Excl. VAT)",
                    thStyle: "width:140px",
                    thClass: "text-center",
                    tdClass: "text-right"
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        dpConfirm: false,
        apDownpay:[],

        lkuApGroupShow:false
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidApLines() {
      this.$v.apLinesObj.$touch();
      return this.$v.apLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    unitprice(){
        return this.apLinesObj.unitprice;
    },
    posttype(){
        return this.apLinesObj.posttype;
    },    
  },
  watch: {
    unitprice: function(newval) {
        setTimeout(() => {
            this.calcPrice();
        }, 100);
    },    
    pasalpph: function(newval) {
        const item = this.lookupPPH.find(p => p.value==newval);
        this.apLinesObj.pph=item.pph;
        setTimeout(() => {
            this.calcTaxes();
        }, 100);
    },    

  },
  created: async function(){

      if (this.$route.params.RecivKey)  {
          toastr.info('Loading AP Detail, please wait')
          try {
            const [a,b,c,data,inventoryAcc, fixedassetAcc] = await Promise.all([apinv.postgroup(), apinv.pasalpph(),apinv.currency(),
                                                            procreceiv.detail(this.$route.params), procreceiv.inventoryAcc(), procreceiv.fixedassetAcc()]) ;
            this.postGroups = a;
            this.lookupPPH = b;
            this.currency = c;
            this.inventoryAcc = inventoryAcc;
            this.fixedassetAcc = fixedassetAcc;
            console.log('inventoryAcc: ', inventoryAcc);
            console.log('fixedassetAcc: ', fixedassetAcc);
            // const data = await procure.detail({ pohdrkey: this.$route.params.pohdrkey }) ;
            const row = data[0][0];
            this.model.RecivKey = row.RecivKey;
            this.model.RecivNo=row.RecivNo;
            this.model.tanggal=row.RecivDate ? moment(row.RecivDate).format('YYYY-MM-DD') : '';;
            this.model.invoice=row.DoNumber || row.RecivNo;
            this.model.invdate=row.DoDate ? moment(row.DoDate).format('YYYY-MM-DD') : '';
            this.model.uraian= row.remark;
            this.model.po = row.orderno;
            this.model.pohdrkey = row.pohdrkey;

            this.model.vendor_id = row.vendor_id;
            this.model.vendor = row.vendor;
            this.model.vendorinfo = row.vendor_name.trim() + ' | ' + row.vendor_code;
            this.model.postgroup = (row.postgrp || '').trim();
            const kelpAp= this.postGroups.find(p=> p.value==this.model.postgroup);
            if (kelpAp) {
                this.model.postgrpname = kelpAp.postgrpname;
            }

            this.model.matauang = row.matauang;
            this.model.ratekurs = 1;
            this.model.chargeable = row.chargeable;
            this.model.DimTableKey = row.DimTableKey;

            setTimeout(() => {
                this.updateDimDtl2Hdr(row);            
            }, 500);

            this.calcVAT = this.calcVAT || 0;
            var lines = data[1];
            this.Lines = data[1];
            this.apLines.items = [];
            this.model.ttlnetto = 0;
            this.model.ttlamtdue = 0;
            this.model.totalpph = 0;
            let nilaippn= 0;
            let newLine;
            for (let i = 0; i < lines.length; i += 1) {
                newLine = {};
                for (let key in lines[i]) {
                    newLine[key] = lines[i][key];
                }
                newLine.ppn= this.tarifPPN;
                newLine.dppnlain= 100;
                newLine.dpp= (lines[i].kenappn==1) ? lines[i].nilainett : 0;
                this.model.ttlnetto = this.model.ttlnetto + (newLine.nilai || 0);
                nilaippn += (newLine.nilaippn || 0);
                this.model.ttlamtdue = this.model.ttlnetto + (this.model.nilaippn || 0);
                this.model.totalpph = this.model.totalpph + (newLine.nilaipph || 0);

                newLine.lineno = i + 1;
                // newLine.uraian_dt = lines[i].itemname.substring(0,250).trim(); lines[i].description.substring(0,250).trim();
                newLine.uraian_dt = (`${(lines[i].itemname || '').trim()} ${(lines[i].description || '').trim()}`).substring(0,250).trim();
                newLine.glAccount = (lines[i].kodeacc) ? (lines[i].kodeacc || '').trim()  : '-- Please select ! -- ';
                // newLine.glAccount = (lines[i].kodeacc) ? (lines[i].kodeacc || '').trim() + ' | ' + (lines[i].itemname || '') : '-- Please select ! -- ';
            
                // let akun=this.inventoryAcc.find(i => i.kodeacc == lines[i].kodeacc);
                let akun=this.inventoryAcc.find(i => i.kodeacc == newLine.kodeacc);
                if (akun){
                    newLine.posttype=1
                    newLine.postname='INVENTORY';
                } else {
                    // akun=this.fixedassetAcc.find(i => i.kodeacc == lines[i].kodeacc);
                    akun=this.fixedassetAcc.find(i => i.kodeacc ==newLine.kodeacc);
                    if (akun){
                        newLine.posttype=2
                        newLine.postname='FIXED ASSET';
                    } else {
                        newLine.posttype=3
                        newLine.postname='EXPENSES';
                    }
                }
                
                this.apLines.items.push(newLine);
            }
            if (this.calcVAT == 1) this.model.nilaippn = 0;
            this.calcTotalDtlAp();
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
            this.model.totalinv = this.model.ttlamtdue;
            this.ordLines=data[2]; //additional 28 May 2021      
            this.otherRcv=data[3]; //additional 28 May 2021  
            this.partialRcvConfirm=false;    
            this.model.partialRcv=0;
            if (this.ordLines.length !== lines.length) {
                this.model.partialRcv=1;
                this.partialRcvConfirm=true;
            } else {
                // if (this.otherRcv.length>0){
                //     console.log('this.otherRcv.length: ', this.otherRcv);
                //     this.model.partialRcv=1;
                // } else {
                    this.Lines.forEach(item => {
                        if (item.quantity<item.QtyPO) {
                            console.log('lines[i].quantity<lines[i].QtyPO: ', lines[i].quantity,lines[i].QtyPO);
                            this.model.partialRcv=1;
                            this.partialRcvConfirm=true;
                        }                                            
                    });
                // }
            }


            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        this.close();
      }
  },
  methods: {
    async showApDownpay() {
        try {
            const data = await apinv.getUangmuka({ vendor_id: this.model.vendor_id, po: this.model.po }) ;
            this.apDownpay = data;
            let ApDpIdx;
            this.apDownpay.forEach((dp,idx)=>{
                dp.selected=0;
                if (dp.po===this.model.po){
                    dp.selected=1;
                } else {
                    ApDpIdx = this.apDpSttl.items.findIndex(d => d.notgl==dp.apinvkey)
                    if (ApDpIdx>-1){
                        dp.selected=1;
                        dp.nilai=this.apDpSttl.items[ApDpIdx].nilai;
                    }
                }
            });
            // console.log('this.apDownpay : ',this.apDownpay);
            this.dpConfirm=true;
        } catch (error) {
            console.log(error);
            // this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    onCancelApDownpay() {
        this.dpConfirm=false;
        this.saveClick=false;
    },
    onSelectApDownpay() {
        if (this.saveClick===true) {
            const totaldp= this.apDownpay.reduce((a, b) => {
                            if (b.selected==1) a += b.nilai;
                            return a; 
                        }, 0);
            if ((this.model.totalap || 0) < totaldp) {
                toastr.error('Nilai Uang Muka yang di alokasikan melebihi total invoice','ERROR MESSAGE',10000);
                return;
            } 
        }
        this.dpConfirm=false;
        // pindahkan ke apDpSttl 
        // yg terselect dan nilainya tidak Nol aja
        let ApDpIdx;
        const dpTerpilih = this.apDownpay.filter(dp => ((dp.selected==1) && (dp.nilai != 0)));
        dpTerpilih.forEach((dp,idx)=>{
            dp.notgl=dp.apinvkey;
            dp.apinvkey= '';
            dp.idrowunik='';
            ApDpIdx = this.apDpSttl.items.findIndex(d => d.notgl==dp.apinvkey)
            if (ApDpIdx>-1){
                dp.idrowunik=this.apDpSttl.items[ApDpIdx].idrowunik;
            }
        });
        this.apDpSttl.items=dpTerpilih;
        if (this.saveClick===true) {
            this.save();
        }
    },
    onSelectLkuCoa(_selected) {
        this.apLinesObj.kodeacc = _selected.kodeacc;
        this.apLinesObj.namaacc = _selected.namaacc;
        this.apLinesObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.lkuCoaShow=false;
        this.apLinesObj.posttype=3
        this.apLinesObj.postname='EXPENSES';
        let akun=this.inventoryAcc.find(i => i.kodeacc == _selected.kodeacc);
        if (akun){
            this.apLinesObj.posttype=1
            this.apLinesObj.postname='INVENTORY';
        } else {
            akun=this.fixedassetAcc.find(i => i.kodeacc == _selected.kodeacc);
            if (akun){
                this.apLinesObj.posttype=2
                this.apLinesObj.postname='FIXED ASSET';
            } else {
                this.apLinesObj.posttype=3
                this.apLinesObj.postname='EXPENSES';
            }
        }

    },
    onSelectLkuApGroup(_selected) {
        this.model.postgroup = _selected.postgrpcode.trim();
        this.model.postgrpname = _selected.postgrpname;
        this.lkuApGroupShow=false;
    },       
    // onSelectLkuAssetcat(_selected) {
    //     this.apLinesObj.iteminfo = _selected.catgname.trim() ;
    //     this.apLinesObj.partnumber = _selected.catgname;
    //     this.apLinesObj.itemno = _selected.catgid;
    //     this.apLinesObj.itemname = _selected.uraian;
    //     this.apLinesObj.kodeacc = _selected.kodeacc;
    //     this.apLinesObj.namaacc = _selected.catgname;
    //     this.lkuAssetcatShow=false;
    // },
    // onSelectLkuItem(_selected) {
    //     this.apLinesObj.iteminfo = _selected.partnumber.trim() + ' | ' + _selected.itemname.trim();
    //     this.apLinesObj.description =  _selected.itemname.trim() + ' | ' + _selected.partnumber.trim();
    //     this.apLinesObj.partnumber = _selected.partnumber;
    //     this.apLinesObj.itemno = _selected.itemno;
    //     this.apLinesObj.itemname = _selected.itemname;
    //     this.lkuItemShow=false;
    // },

    // showLkuCashflow(callerObj) {
    //     this.lkuCashflowShow=true;
    //     this.lkuCashflowCaller=callerObj;
    // },
    // onSelectLkuCashflow(lkuData) {
    //     this.lkuCashflowData=lkuData;
    //     this.lkuCashflowShow=false;
    //     this[this.lkuCashflowCaller].cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
    //     this[this.lkuCashflowCaller].kodecash = lkuData.selected.kodecash;
    //     this[this.lkuCashflowCaller].namacash = lkuData.selected.namacash;
    //     if ((this.model.cashflow || '') == '') {
    //         this.model.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
    //         this.model.kodecash = lkuData.selected.kodecash;
    //         this.model.namacash = lkuData.selected.namacash;
    //     }
    //     this.lkuCashflowShow=false;
    // },
    calcPrice : function() {
        this.apLinesObj.nilai = parseFloat(this.apLinesObj.quantity) * parseFloat((this.apLinesObj.unitprice || 0));
        this.calcTaxes();
    },
    calcTaxes : function() {
        this.apLinesObj.dppnlain=parseFloat(this.apLinesObj.dppnlain) || 100; 
        this.apLinesObj.nilainett = parseFloat(this.apLinesObj.nilai);
        this.apLinesObj.dpp = parseFloat(this.apLinesObj.nilainett) * parseFloat(this.apLinesObj.dppnlain) / 100;
        this.apLinesObj.ppn = this.apLinesObj.ppn || this.tarifPPN;
        this.apLinesObj.nilaippn = 0;
        this.apLinesObj.nilaidue = this.apLinesObj.nilainett ;
        this.apLinesObj.nilaipph = 0;
        // if (this.apLinesObj.kenappn == 1) {
        //     this.model.grossup = 0;
        //     this.apLinesObj.nilaippn = (this.apLinesObj.ppn/100) * this.apLinesObj.dpp;
        // } else {
        //     this.apLinesObj.nilaippn = 0;
        // }
        // if (this.model.grossup == 1)
        //     this.apLinesObj.dpp = this.apLinesObj.dpp * (100 / (100 - this.apLinesObj.pph));

        // this.apLinesObj.nilaidue = this.apLinesObj.nilainett + this.apLinesObj.nilaippn;
        // if (this.calcPPh == 1) {
        //     this.apLinesObj.nilaipph = this.apLinesObj.dpp * parseFloat(this.apLinesObj.pph) / 100
        // }
        this.$forceUpdate();
    },

    calcAmountDue : function() {
        this.model.ttlamtdue = parseFloat(this.model.ttlnetto || 0) + parseFloat(this.model.nilaippn || 0);
        this.model.totalap= (this.model.grossup==0) ? this.model.ttlamtdue : this.model.ttlamtdue-this.model.totalpph;
        console.log('Total AP : ',this.model.totalap);
        toastr.info(`Total AP after W/H Tax : ${this.model.totalap.toLocaleString(undefined, { maximumFractionDigits: 2 })}`);
    },    

    addApLines : function () {
        const obj={_showDetails:true};
        this.apLines.selected = obj;
        // for (var key in this.apLinesObj) {
        //     this.apLinesObj[key] = '';
        // }
        // this.apLinesObj.unitsize='EACH';
        this.apLinesObj.quantity = 1;
        // this.apLinesObj.kenappn = 1;
        this.apLinesObj.dppnlain = 100;
        this.apLinesObj.ppn = this.tarifPPN;
        this.apLinesObj.unitprice= 0;
        // this.apLinesObj.pasalpph='N/A',
        // this.apLinesObj.pph = 0;
        this.apLinesObj.kodeacc='';
        this.apLinesObj.uraian_dt='';
        this.apLinesObj.DimTableKey='';
        this.apLinesObj.nilai=0;
        this.updateDimHdr2Dtl(this.apLinesObj);
        this.apLines.items.push(obj);
        this.apLines.total=this.apLines.items.length;
    },
    editApLines : async function (obj,callback) {
        this.apLines.selected = obj;
        // for (var key in this.apLinesObj) {
        //     this.apLinesObj[key] = '';
        // }
        this.apLinesObj.kodeacc = '';
        this.apLinesObj.uraian_dt = '';
        this.apLinesObj.quantity = 0;
        this.apLinesObj.unitprice = 0;
        this.apLinesObj.nilai = 0;
        this.apLinesObj.nilaipph = 0;
        this.apLinesObj.ppn = 0;
        this.apLinesObj.kenappn = 0;
        this.apLinesObj.pasalpph =  'N/A';
        this.apLinesObj.pph = 0; 
        this.apLinesObj.unitzise = '';
        this.apLinesObj.DimTableKey = '';
        
        this.calcPPh=obj.calcPPh||1;
        for (var key in obj) {
            this.apLinesObj[key] = obj[key];
        }
        this.apLinesObj.ppn= this.apLinesObj.ppn || this.tarifPPN;
        this.apLinesObj.pph = this.apLinesObj.pph || 0;
        this.apLinesObj.dppnlain= this.apLinesObj.dppnlain || 100;
        this.apLinesObj.nilaipph= this.apLinesObj.nilaipph || 0;
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.apLinesObj[dim.value] = obj[dim.value];
                this.apLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.apLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        if (this.apLinesObj.kodeacc) {
          const _selected = await apinv.findcoa({kodeacc: this.apLinesObj.kodeacc, tahun: this.tahun});
          if (_selected) this.apLinesObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        }

        callback();
    },
    delApLines: function (index) {
        if (index > -1) {
        this.apLines.items.splice(index, 1);
        }
        this.apLines.total=this.apLines.items.length;
        this.calcTotalDtlAp();
    },
    saveApLines: async function (callback) {
        this.calcTaxes();
        if (this.invalidApLines) {
            console.log('validation : ', this.$v.apLinesObj);
            toastr.error('Please fill the form Detail/Line correctly.', "ERROR MESSAGE");
       } else {
            let datadim=this.apLinesObj;
            datadim.TableName = 'ap_invoice_dt';
            try {
                const dimValResult = await dimension.validate(datadim);
                if (dimValResult.success) {
                    for (var key in this.apLinesObj) {
                        this.apLines.selected[key] = this.apLinesObj[key];
                    }
                    this.dimension.forEach((dim) => {
                        if (datadim[dim.value]) {
                            this.apLines.selected[dim.value] = datadim[dim.value];
                            this.apLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                        }
                    });
                    this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtlAp();
                    this.apLines.selected._showDetails=false;
                    if (callback) callback();
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message;
                    if (callback) callback(new Error(msg));
                    else {
                        toastr.error(msg, "ERROR MESSAGE",10000);
                    }
                }
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if ( (Math.abs(this.model.totalinv - parseFloat(this.model.ttlamtdue))>0.5) && (this.model.tagihandp == 0)) {
            toastr.error('[Total Invoice] not Balance with [Total Detail Invoice]', "ERROR MESSAGE",10000);
        } else {
            console.log('this.model.partialRcv : ',this.model.partialRcv);            
            if (this.model.partialRcv == 1) {
                if (this.partialRcvConfirm==true){
                    this.saveUnbillAP();
                    // const pesan=`It is PARTIAL RECEIVING (Qty Received is less then QTY Purchase Order) ?`;
                    // this.$bvModal.msgBoxConfirm(pesan, {
                    // title: 'Please Confirm',
                    // size: 'sm',
                    // buttonSize: 'sm',
                    // okVariant: 'success',
                    // okTitle: 'YES',
                    // cancelTitle: 'NO',
                    // footerClass: 'p-2',
                    // hideHeaderClose: false,
                    // centered: true
                    // })
                    // .then(async(value) => {
                    //     if (value==true){
                    //         this.model.partialRcv=1;
                    //         this.saveUnbillAP();
                    //     } else {
                    //         this.model.partialRcv=0;
                    //         this.saveAP();
                    //     }
                    // })
                    // .catch(err => {
                    //     toastr.error(JSON.stringify(err),'ERROR MESSAGE',10000);
                    // // An error occurred
                    // })
                } else {
                    this.saveUnbillAP();
                }                           
            } else {
                // buka partial receiving langsung jadi AP
                this.saveAP();
            }
        }
    },
    saveUnbillAP: async function() {
        toastr.info(' PARTIAL RECEIVING save as AP UN BILL','INFO MESSAGE',10000);
        try {
                this.saveEnabled=false;
                this.model.apinvkey = '';
                this.model.nomor = this.model.nomor || '';
                const row = {};
                for (var key in this.model) {
                    row[key] = this.model[key];
                }
                row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : undefined;
                row.duedate = row.duedate ? moment(row.duedate).format('YYYY-MM-DD') : undefined;
                row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : undefined;
                if (this.model.tagihandp==0) this.model.termin='';
                
                let lineno=1;
                let newApLines = this.apLines.items.reduce((newArr, item) => {
                    if ((item.kodeacc || '') != '') {
                        item.lineno = lineno;
                        newArr.push(item);
                        lineno += 1;
                    }
                    return newArr;
                }, []);

                row.lines = newApLines;
                const hasil= await procreceiv.apunbill(row);
                toastr.success(`Success, Trx.Number ${hasil.RecivNo}`, "Save AP UNBILL",10000);
                this.close();        
            
        } catch (error) {            
            this.saveEnabled=true;
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },
    saveAP: async function(){
        this.saveEnabled=false;
        if (this.saveClick===false)  {
            this.saveClick=true;
            this.saveEnabled=true;   
            this.showApDownpay();         
            return;
        }              
        try {
            this.model.TableName = 'ap_invoice_tt';
            const dimValResult = await dimension.validate(this.model);
            if (dimValResult.success) {
                // this.model.DimTableKey = diisi dari PO;
                this.model.apinvkey = '';
                this.model.nomor = this.model.nomor || '';
                const row = {};
                for (var key in this.model) {
                    row[key] = this.model[key];
                }
                row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : undefined;
                row.duedate = row.duedate ? moment(row.duedate).format('YYYY-MM-DD') : undefined;
                row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : undefined;
                if (this.model.tagihandp==0) this.model.termin='';
                
                let lineno=1;
                let newApLines = this.apLines.items.reduce((newArr, item) => {
                    if ((item.kodeacc || '') != '') {
                        item.lineno = lineno;
                        newArr.push(item);
                        lineno += 1;
                    }
                    return newArr;
                }, []);

                row.lines = newApLines;
                row.apDpSttl = this.apDpSttl.items;

                // const hasil= await apinv.savenpost(row);
                const hasil= await apinv.insert(row);
                toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save AP",10000);

                this.close();
            } else {
                this.saveEnabled=true;
                console.log('dimValResult : ', dimValResult);
                var msg = dimValResult.message || 'Dimension validation error';
                toastr.error(msg, "Save as AP Error");
            }

        } catch (error) {
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
            this.saveEnabled=true;            
        }
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.apLinesObj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    // calcTotalDtlAp: function () {
    //     this.apLines.total=this.apLines.items.length;
    //     this.calcVAT = this.calcVAT || 1;
    //     let nilaippn = 0;
    //     let ttlnetto = 0;
    //     // let ttlamtdue = 0;
    //     let totalpph = 0;
    //     if (this.apLines.items){
    //         this.apLines.items.forEach((trx)=> {
    //             if (trx.kodeacc) {
    //                 ttlnetto += (trx.nilai || 0);
    //                 nilaippn += (trx.nilaippn || 0);
    //                 // ttlamtdue = ttlnetto + (nilaippn || 0);
    //                 totalpph += parseFloat(trx.nilaipph || 0);
    //             }
    //         });
    //     } 
    //     this.model.ttlnetto = ttlnetto;
    //     this.model.totalpph = totalpph;
    //     if (this.calcVAT == 1){
    //         this.model.nilaippn = nilaippn;
    //     }
    //     this.model.ttlamtdue = this.model.ttlnetto+this.model.nilaippn;
    //         if (this.model.grossup==1) {
    //             this.model.totalap = this.model.ttlamtdue;
    //         } else {
    //             this.model.totalap = this.model.ttlamtdue - this.model.totalpph;
    //         }
    // },
    calcTotalDtlAp: function () {
        try {
            this.apLines.total=this.apLines.items.length;
            // this.calcVAT = this.calcVAT || 1;
            // let nilaippn = 0;
            let ttlnetto = 0;
            // let ttlamtdue = 0;
            // let totalpph = 0;
            // console.log('this.apLines.items : ',this.apLines.items);
            this.apLines.items.forEach((trx)=> {
                // if (trx.kodeacc) {
                    ttlnetto += (trx.nilainett || 0);
                    // nilaippn += (trx.nilaippn || 0);
                    // ttlamtdue = ttlnetto + (nilaippn || 0);
                    // totalpph += parseFloat(trx.nilaipph || 0);
                // }
            });
            this.model.ttlnetto = ttlnetto;
            // this.model.totalpph = totalpph;
            // if (this.calcVAT == 1){
            //     this.model.nilaippn = nilaippn;
            // }
            // this.model.ttlamtdue = this.model.ttlnetto+this.model.nilaippn;
            this.model.ttlamtdue = this.model.ttlnetto;
            // if (this.model.grossup==1) {
                this.model.totalap = this.model.ttlamtdue;
            // } else {
            //     this.model.totalap = this.model.ttlamtdue - this.model.totalpph;
            // }
            this.model.totalinv = this.model.ttlamtdue;
        } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            
        }
    },

    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    //         if ( this.tahun != newVal) {
    //             this.tahun=newVal ;
    //             apinv.getcoa({ tahun: this.tahun}).then(result => {
    //                     this.coa = result;
    //                     if  (this.coa.length==0) {
    //                         this.getCoa();
    //                     }                        
    //                 })
    //                 .catch(err => {
    //                     console.log('get COA -> ', err);
    //                 });
    //         } else if  (this.coa.length==0) {
    //             this.getCoa();
    //         }
    // },
    // getCoa: function(){
    //     this.tahun=(this.$store.state.user.tglaktif || '').substring(0,4)                
    //     apinv.getcoa({ tahun: this.tahun}).then(result => {
    //             this.coa = result;
    //         })
    //         .catch(err => {
    //             console.log('get COA -> ', err);
    //         });
    },    
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.receivingposting')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
